var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 93,
    viewBox: "0 0 94 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_182)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_188_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.1205 14.3218C70.5436 5.81785 59.1337 1.13156 46.9902 1.12671C34.8741 1.12671 23.4461 5.80885 14.8127 14.3107C6.164 22.8272 1.39664 34.145 1.3855 46.138V46.1602C1.38689 53.4191 3.30317 60.7418 6.94068 67.426L1.51019 91.9909L26.4775 86.339C32.801 89.5105 39.8566 91.1826 46.9729 91.1853H46.9909C59.105 91.1853 70.533 86.5025 79.1678 78C87.8241 69.4766 92.5936 58.1733 92.5992 46.1727C92.6027 34.2566 87.8165 22.9451 79.1205 14.3218ZM46.9902 84.0935H46.9742C40.5845 84.0908 34.2533 82.4943 28.6661 79.4752L27.4854 78.8374L10.8833 82.5955L14.4895 66.2849L13.7942 65.0918C10.3379 59.1598 8.51146 52.6115 8.51146 46.1526C8.52469 25.2465 25.7845 8.21854 46.9889 8.21854C57.2327 8.2227 66.8579 12.1748 74.0912 19.3457C81.4338 26.6276 85.476 36.154 85.4726 46.1706C85.4642 67.0814 68.201 84.0935 46.9902 84.0935Z",
    fill: "#0360D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5808 26.3027H32.5816C31.8857 26.3027 30.7558 26.5619 29.8002 27.597C28.8438 28.6326 26.1487 31.1359 26.1487 36.227C26.1487 41.3183 29.8873 46.2374 30.4083 46.9286C30.9301 47.6191 37.6248 58.4003 48.2281 62.548C57.0405 65.9947 58.8341 65.3091 60.7462 65.1365C62.6591 64.9646 66.9185 62.634 67.7879 60.218C68.6572 57.8021 68.6572 55.7307 68.3967 55.2981C68.1354 54.8669 67.4396 54.6083 66.3969 54.0912C65.3534 53.5734 60.2405 51.0277 59.2841 50.6818C58.3277 50.3372 57.6326 50.1647 56.9367 51.201C56.2407 52.2354 54.1921 54.6284 53.5833 55.3188C52.9752 56.01 52.3664 56.0966 51.3229 55.5788C50.2795 55.0597 46.954 53.9477 42.9689 50.4232C39.8671 47.6801 37.7147 44.182 37.1059 43.1463C36.4978 42.1113 37.041 41.5511 37.5642 41.0347C38.033 40.5716 38.6661 39.938 39.1879 39.3341C39.7089 38.7297 39.8574 38.2985 40.2056 37.6081C40.5532 36.9176 40.379 36.313 40.1185 35.7959C39.8574 35.2781 37.8554 30.1613 36.9276 28.1148C36.146 26.3914 35.324 26.3332 34.5808 26.3027Z",
    fill: "#0360D8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.1358,
    height: 92,
    fill: "white",
    transform: "translate(0.586304 0.401367)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_188_182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.1358,
    height: 92,
    fill: "white",
    transform: "translate(0.586304 0.401367)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappVector);
export default __webpack_public_path__ + "static/media/whatsapp_vector.917ecd99b5769508f5d71a7ac5a06ce1.svg";
export { ForwardRef as ReactComponent };